import { useQuery } from "@apollo/client";
import { VerticalDivider } from "Components/Divider";
import { MainFooter } from "Components/MainFooter";
import { PageWrapper } from "Components/MainPageWrapper";
import { Section, Subsection } from "Components/Section";
import { ApplicationType, PartnerQuery, partnerQuery } from "generated/graphql";
import querystring from "query-string";
import React from "react";
import { useLocation } from "react-router-dom";
import { serverConstants } from "Shared/Constants";
import { TransitionLogo } from "./LcpWorkflow/LcpWorkflowPageWrapper";
import { NotFoundPage } from "./NotFoundPage";

export function LandingPage() {
  const { search } = useLocation();
  const partner: string = (querystring.parse(search).partner as string) ?? "";
  const { data } = useQuery(partnerQuery, {
    variables: { key: partner },
  });
  if (!data) {
    return <>Loading...</>;
  } else if (!data.partner) {
    return <NotFoundPage />;
  }
  const title = `Insurance from ${data.partner.name} and ${serverConstants.CompanyName}`;
  return (
    <PageWrapper
      documentTitle={title}
      theme={{ mainDivStyle: { maxWidth: "769px" } }}
      header={<LandingHeader partner={data.partner} />}
      footer={<MainFooter />}
    >
      <Section title={title}>
        {data.partner.allowedProgramTypes.map(programType => (
          <ApplicationTypeSummary key={programType} programType={programType} />
        ))}
      </Section>
    </PageWrapper>
  );
}

export function LandingHeader(props: {
  partner: NonNullable<PartnerQuery["partner"]>;
}) {
  return (
    <header
      id="header"
      className="has-background-white"
      style={{ padding: "1em" }}
    >
      <nav className="is-flex" style={{ justifyContent: "center" }}>
        <img
          alt={`${props.partner.name} Logo`}
          src={props.partner.logoFilePath}
          style={{
            maxHeight: 80,
          }}
        />
        <VerticalDivider style={{ marginLeft: "2em", marginRight: "2em" }} />
        <TransitionLogo />
      </nav>
    </header>
  );
}

export function ApplicationTypeSummary(props: {
  programType: ApplicationType;
}) {
  switch (props.programType) {
    case ApplicationType.PLAINTIFF:
      return (
        <Subsection title={`Plaintiff ${serverConstants.InsuranceName}`}>
          <div>
            {serverConstants.InsuranceName} is insurance to cover costs spent by
            plaintiffs’ attorneys and litigants in furtherance of the case.
            {serverConstants.InsuranceName} is sold on a case-by-case basis,
            providing a unique opportunity to insure each case’s individual cost
            disbursements. {serverConstants.InsuranceName} covers costs spent in
            furtherance of litigation including expert costs, deposition
            transcripts, travel costs (hotels, airfare and ancillary travel
            expenses), filing fees, trial exhibits, mediator expenses, copies,
            e-discovery, and all other costs spent directly on the case.
          </div>
          <div className="has-text-centered">
            <a
              href={`${window.origin}/?type=${props.programType}`}
              className="button is-primary"
            >
              Get a Quote
            </a>
          </div>
        </Subsection>
      );
    default:
      return <></>;
  }
}
